// Versione applicazione Synappsi
// Format: MAJOR.MINOR — MINOR è il numero di distribuzione (deploy) su produzione.
// Quando MINOR raggiunge 100, incrementa MAJOR e riparti da 00.
// Esempio: 1.99 → 2.00, 2.99 → 3.00, ecc.
export const APP_VERSION = "2.17";
